/**
 * @summary Top main menu component.
 */

import { h, Component } from 'preact';
import Menu from './Menu';
import MainMenuDrawer from './MainMenuDrawer';
import throttle from 'lodash/throttle';

/**
 * @summary Main menu preact component.
 *
 * @export
 * @class
 * @extends {Component}
 */
export default class MainMenu extends Component {
	constructor( props ) {
		super( props );

		this.state = {
			shownCount: 0
		};

		this.itemElements = [];
	}

	componentDidMount() {
		this.resizeWatch();
		this.resizeWatch = throttle( this.resizeWatch.bind( this ), 200 );
		window.addEventListener( 'resize', this.resizeWatch );
	}

	componentWillUnmount() {
		window.removeEventListener( 'resize', this.resizeWatch );
	}

	/**
	 * @summary Maintains single line top-level layout of the menu items.
	 *
	 * @listens document:resize
	 */
	resizeWatch() {
		const first = this.itemElements[0];

		let shownCount = 1;
		for ( let element of this.itemElements.slice( 1 ) ) {
			if ( element.offsetTop > first.offsetTop ) {
				break;
			}

			shownCount++;
		}

		if ( shownCount === this.itemElements.length ) {
			shownCount = 999;
		}

		this.setState({
			shownCount
		});
	}

	render({ menuTree, localizedStrings }, { shownCount }) {
		const topMenuTree = menuTree.map( ( item, i ) => {
			return Object.assign({}, item, {
				itemRef: element => this.itemElements[i] = element,
				hidden: i >= shownCount
			});
		});

		const style = this.itemElements.length > 0 && {
			height: `${this.itemElements[0].offsetHeight}px`,
			visibility: shownCount < 2 ? 'hidden' : ''
		};

		return (
			<div class="c-primary-menu">
				<Menu menuTree={topMenuTree} style={style} />
				<MainMenuDrawer
					classes="c-primary-menu__drawer"
					menuTree={menuTree}
					localizedStrings={localizedStrings}
					hide={shownCount > this.itemElements.length}
				/>
			</div>
		);
	}
};



// WEBPACK FOOTER //
// ./src/js/components/MainMenu.js